module.exports = __webpack_public_path__ + "img/overlay-bg-about-us-mobile.5ae82208.png";